/**
 * @enum {String}
 */
export const EventFirstTareService = {
  FirstTareService: 'FirstTareService',
};

/**
 * @enum {String}
 */
export const EventCheckUpdateSystem = {
  CheckingVersionUpdate: 'CheckingVersionUpdate',
};

/**
 * @enum {String}
 */
export const EventLicenseService = {
  initialLicenseService: 'initialLicenseService',
  LicenseInfoService: 'LicenseInfoService',
  LicenseModalService: 'LicenseModalService',
  TrialLicenseModalService: 'TrialLicenseModalService',
  ActivateLicenseManual: 'ActivateLicenseManual',
  TrialLicenseDayLeftInfoService: 'TrialLicenseDayLeftInfoService',
};

/**
 * @enum {String}
 */
export const StopEvent = {
  STOP_PROCESS: 'STOP_PROCESS',
  PAUSE_PROCESS: 'PAUSE_PROCESS',
  RECOVERY_OPTION: 'RECOVERY_OPTION',
};

/**
 * @enum {String}
 */
export const RecoveryOfLiquidEvent = {
  SHOW_POP_UP: 'SHOW_POP_UP_ROL',
  HIDE_POP_UP: 'HIDE_POP_UP_ROL',
};

/**
 * @enum {String}
 */
export const ManualControlEventTopMenu = {
  EnableManualControlTopMenu: 'EnableManualControlTopMenu',
  StartManualControlTopMenu: 'StartManualControlTopMenu',
  StopManualControlTopMenu: 'StopManualControlTopMenu',
  CancelManualControlTopMenu: 'CancelManualControlTopMenu',
  StartManualControlOnHoldTopMenu: 'StartManualControlOnHoldTopMenu',
  StopManualControlOnHoldTopMenu: 'StopManualControlOnHoldTopMenu',
};

/**
 * @enum {String}
 */
export const AutoProfileEvent = {
  OpenHelpMenu: 'OpenHelpMenu',
};

/**
 * @enum {String}
 */
export const RunAutoProfileEvent = {
  AUTORUN: 'RunAutoProfile',
};

/**
 * @enum {String}
 */
export const CalibrationScaleEvent = {
  SET_TOP_MENU: 'setTopMenuCalibrationScale',
  SET_TOP_MENU_UNCOMPLATE: 'setTopMenuUnCompleteCalibrationScale',
  SET_TOP_MENU_COMPLATE: 'setTopMenuCompleteCalibrationScale',
};

/**
 * @enum {String}
 */
export const LockStatusPageEvent = {
  LOCK_UNLOCK_CONCENTRATOR: 'LOCK_UNLOCK_CONCENTRATOR',
  ON_CLICK_LOCK_CONCENTRATOR: 'ON_CLICK_LOCK_CONCENTRATOR',
};
